import React, { PureComponent } from "react";
import { Collapse } from 'reactstrap';
import Util from "../../common/util/util";
import "./NoOptionsPetPlan.component.css";
import Helpers from "../../common/util/Helpers";

class NoOptionsPetPlan extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { collapse: false };
    }

    toggle = () => {
        this.setState({ collapse: !this.state.collapse });
    }
    render() {
        const { MonthlyPremium, Name, PetType, Age, Breed, Reimbursement, Deductible, AnnualLimit } = this.props.plan


        return (
            <div className="d-inline col-md-6 no-options-pet-plan">
                <div className="px-2 align-top">
                    <div className="mb-3 pet-list-panel-container">
                        <div className="row">
                            <div className="col mb-2" style={{ paddingRight: "10px", paddingLeft: "10px" }}>
                                <div className="pet-details-edit">
                                    <div className="pet-details-info">
                                        <h2 className="pet-details-name font-weight-bold">
                                            {Helpers.truncateWithEllipsis(Name, 20)},
                                        </h2>
                                        <div className="mt-2">
                                            <span className="pet-details-age-breed pet-details-truncate">{Age === 0 ? (PetType === "dog" ? "Puppy" : "Kitten") : "Age " + Age}, {Breed}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row p-3 overflow-hidden pet-list-panel">
                            <div className="col-12">
                                <div className="pet-plan-header">
                                    <div className="font-weight-bold mb-2 new-premium-header">New Monthly Premium as of {Util.getFormattedDate(this.props.policyEffectiveDate)}</div>
                                    <table className="coverage-table">
                                        <tr>
                                            <td><span className="coverage-table-label">Reimbursement:</span></td>
                                            <td>{Reimbursement}</td>
                                        </tr>
                                        <tr>
                                            <td><span className="coverage-table-label">Annual Deductible:</span></td>
                                            <td>{Deductible}</td>
                                        </tr>
                                        <tr>
                                            <td><span className="coverage-table-label">Maximum Payouts:</span></td>
                                            <td>Unlimited</td>
                                        </tr>
                                    </table>
                                    <div className="font-weight-bold premium-text">{MonthlyPremium}<small className="month-text">/month</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoOptionsPetPlan;